(function () {
  "use strict";

  if (window.BitebackConsultationAnalyticsBound) return;
  window.BitebackConsultationAnalyticsBound = true;

  var EVENT_MAP = {
    consultation_started: "biteback:consultation_started",
    answer_selected: "biteback:consultation_answered",
    consultation_completed: "biteback:consultation_completed",
    consultation_abandoned: "biteback:consultation_abandoned",
    product_clicked: "biteback:consultation_product_clicked",
    add_to_cart: "biteback:consultation_added_to_cart"
  };

  function pathwayKey(detail) {
    var keys = (detail.pathway || []).map(function (answer) {
      return answer.choiceKey;
    });
    return [detail.journey && detail.journey.key].concat(keys).filter(Boolean).join(">");
  }

  function pathwayLabel(detail) {
    var labels = (detail.pathway || []).map(function (answer) {
      return answer.choiceLabel;
    });
    return [detail.journey && detail.journey.name].concat(labels).filter(Boolean).join(" → ");
  }

  function normaliseProduct(product) {
    product = product || {};
    return {
      product_key: product.key || null,
      product_id: product.shopifyProductReference || product.productId || product.key || null,
      product_title: product.title || null,
      variant_id: product.variantGid || product.variantId || null,
      relationship_key: product.relationshipKey || null
    };
  }

  function normalise(detail) {
    detail = detail || {};
    var context = detail.context || {};
    return Object.assign(
      {
        attempt_id: detail.attemptId || null,
        journey_key: detail.journey && detail.journey.key || null,
        journey_name: detail.journey && detail.journey.name || null,
        pathway_key: pathwayKey(detail),
        pathway: pathwayLabel(detail),
        recommendation_key: detail.recommendationKey || detail.result && detail.result.recommendationKey || null,
        component_location: context.componentLocation || detail.componentLocation || null,
        presentation_mode: context.presentationMode || detail.presentationMode || null,
        reason: detail.reason || null
      },
      normaliseProduct(detail.product)
    );
  }

  function publish(name, payload) {
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== "function") {
      return;
    }

    try {
      window.Shopify.analytics.publish(name, payload);
    } catch (error) {
      console.warn("Biteback consultation analytics event could not be published.", error);
    }
  }

  Object.keys(EVENT_MAP).forEach(function (domEventName) {
    document.addEventListener(domEventName, function (event) {
      var detail = event.detail || {};
      publish(EVENT_MAP[domEventName], normalise(detail));

      if (domEventName !== "consultation_completed" || !detail.result) return;
      (detail.result.products || []).forEach(function (product) {
        publish(
          "biteback:consultation_recommendation_product",
          Object.assign(normalise(detail), normaliseProduct(product))
        );
      });
    });
  });
})();
